import React from "react";

const InfReels = () => {
  return (
    <>
      <div className="tab-content-section">
        <div className="row mt-3">
          <h4 className="mb-3">Top Reels</h4>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="/mnt/data/B4C058CB-A637-45AB-B5C2-B804B1E298A9.png"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">April 14, 2024 12:46 PM</p>
                <p className="mb-0">NISM - SEBI Investor Certification...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="/mnt/data/B4C058CB-A637-45AB-B5C2-B804B1E298A9.png"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">July 4, 2024 2:51 PM</p>
                <p className="mb-0">IPO Allotment Hack Part 2...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="/mnt/data/B4C058CB-A637-45AB-B5C2-B804B1E298A9.png"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">October 10, 2024</p>
                <p className="mb-0">Stock market strategy reel...</p>
              </div>
            </a>
          </div>
        </div>

        <div className="row mt-4">
          <h4 className="mb-3">Recent Reels</h4>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="/mnt/data/B4C058CB-A637-45AB-B5C2-B804B1E298A9.png"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">January 12, 2026</p>
                <p className="mb-0">Latest IPO insights reel...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="/mnt/data/B4C058CB-A637-45AB-B5C2-B804B1E298A9.png"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">January 11, 2026</p>
                <p className="mb-0">Market crash explained...</p>
              </div>
            </a>
          </div>

          <div className="col-md-4">
            <a href="#" className="text-decoration-none text-dark">
              <div className="p-3 border rounded">
                <img
                  src="/mnt/data/B4C058CB-A637-45AB-B5C2-B804B1E298A9.png"
                  className="img-fluid rounded mb-2"
                />
                <p className="text-muted small mb-1">January 10, 2026</p>
                <p className="mb-0">Beginner investing tips...</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfReels;
